import React, { useEffect } from 'react';

const PerformanceMonitor: React.FC = () => {
  useEffect(() => {
    // Only track in development
    if (process.env.NODE_ENV !== 'development') {
      return;
    }

    const logPerformanceMetrics = () => {
      if ('PerformanceObserver' in window) {
        console.log('🚀 Performance Monitor Started');
        
        // Measure First Contentful Paint
        const fcpObserver = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          const fcp = entries[entries.length - 1];
          console.log(`🎨 FCP (First Contentful Paint): ${fcp.startTime.toFixed(0)}ms`);
        });
        fcpObserver.observe({ entryTypes: ['paint'] });

        // Measure Largest Contentful Paint
        const lcpObserver = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          const lcp = entries[entries.length - 1];
          console.log(`📊 LCP (Largest Contentful Paint): ${lcp.startTime.toFixed(0)}ms`);
        });
        lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });

        // Measure First Input Delay
        const fidObserver = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          const fid = entries[entries.length - 1] as any;
          const delay = fid.processingStart - fid.startTime;
          console.log(`⚡ FID (First Input Delay): ${delay.toFixed(0)}ms`);
        });
        fidObserver.observe({ entryTypes: ['first-input'] });

        // Measure Cumulative Layout Shift
        const clsObserver = new PerformanceObserver((list) => {
          let clsValue = 0;
          for (const entry of list.getEntries()) {
            const layoutShiftEntry = entry as any;
            if (!layoutShiftEntry.hadRecentInput) {
              clsValue += layoutShiftEntry.value;
            }
          }
          console.log(`📐 CLS (Cumulative Layout Shift): ${clsValue.toFixed(3)}`);
        });
        clsObserver.observe({ entryTypes: ['layout-shift'] });

        // Log overall performance summary after 3 seconds
        setTimeout(() => {
          console.log('📈 Performance Summary:');
          console.log('   - Check the metrics above for Core Web Vitals');
          console.log('   - Green: Excellent (< 50% of threshold)');
          console.log('   - Yellow: Good (< threshold)');
          console.log('   - Red: Needs improvement (> threshold)');
          console.log('   - FCP threshold: 1800ms');
          console.log('   - LCP threshold: 2500ms');
          console.log('   - FID threshold: 100ms');
          console.log('   - CLS threshold: 0.1');
        }, 3000);
      }
    };

    // Wait for page to load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', logPerformanceMetrics);
    } else {
      logPerformanceMetrics();
    }
  }, []);

  // Return null - no UI component
  return null;
};

export default PerformanceMonitor;
